import common from '../../en/pages/common';

export default {
    ...common,
    filters: {
        ...common.filters,
        minAmount: "Min amount ($)",
        maxAmount: "Max amount ($)"
    }
};
